module.exports = __webpack_public_path__ + "static/noticias-08-a5f9f370ffe786922e6f7406b6914205.jpg";